/**
 * El engranaje de «Configuración»: mi cuenta, y si el rol lo permite, equipo
 * y alertas.
 *
 * Dibujado a mano, como `OjoIcono`, y por la misma razón: es una sola forma,
 * no justifica traer una biblioteca de iconos completa para dibujarla.
 */
export function EngranajeIcono() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="2.6" fill="none" stroke="currentColor" strokeWidth="1.8" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angulo) => {
        const rad = (angulo * Math.PI) / 180;
        const x1 = 12 + 7.5 * Math.cos(rad);
        const y1 = 12 + 7.5 * Math.sin(rad);
        const x2 = 12 + 9.8 * Math.cos(rad);
        const y2 = 12 + 9.8 * Math.sin(rad);
        return (
          <line
            key={angulo}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        );
      })}
    </svg>
  );
}
